import classnames from "classnames";
import { BlueOutlineButton } from "components/components/BlueOutlineButton/BlueOutlineButton";
import { SvgIconName } from "components/components/Icon/Icon";
import { IconSize } from "components/components/Icon/IconWrapper";

interface FilterButtonProps {
  buttonText: string;
  onClick: () => void;
  isActive?: boolean;
  className?: string;
  dataTestId?: string;
}

export const FilterButton: React.FC<FilterButtonProps> = ({
  buttonText,
  onClick,
  isActive = false,
  className,
  dataTestId,
}) => (
  <BlueOutlineButton
    type="button"
    onClick={onClick}
    className={classnames({ active: isActive }, className)}
    dataTestId={dataTestId}
    buttonText={buttonText}
    iconName={SvgIconName.Filter}
    iconSize={IconSize.xSmall}
  />
);
